const Spinner = () => {
    return (
        <div className="spinner">
            <div className="loadingio-spinner-dual-ring-999dtroszrt"><div className="ldio-tjuxep0cgn">
            <div></div><div><div></div></div>
            </div></div>
        </div>
    )
}

export default Spinner
